import { Button, Form, Input, Modal } from "antd";
import { Header } from "antd/es/layout/layout";
import React, { useEffect, useState } from "react";
import TempalteItemList from "./TempalteItemList";
import { collection, doc, getDoc, getDocs, query, updateDoc, where } from "firebase/firestore";
import { auth, db } from "../../../../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { useParams } from "react-router-dom";
import { toast } from "react-hot-toast";

const NewTemplate = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [user, loading] = useAuthState(auth);

  const [companyName, setCompanyName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const [inspectionDetail, setInspectionDetail] = useState([]);
  console.log("inspectionDetail:",inspectionDetail)
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res.companyName);
      });
      setIsCompanyNameFetched(true);
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };
  useEffect(() => {
    fetchCompanyName();

  }, [user, loading]);

  const { id } = useParams();

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    const fetchInspections = async () => {
      try {
        const userRef = collection(db, "companies", companyName, "inspectionsTemplates");

        const docSnapshot = await getDoc(doc(userRef, id));

        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          setInspectionDetail(data);
        } else {
          console.log("No inspection found with the specified ID.");
        }
      } catch (error) {
        console.error(error);
        alert(error.message);
      }
    };
    fetchInspections();

  }, [companyName, isCompanyNameFetched,isModalOpen]);


  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onFinish = async (values) => {
    const userRef = collection(db, "companies", companyName, "inspectionsTemplates");
    try {
      const inspectionDocRef = doc(userRef, id);
      const inspectionDocSnapshot = await getDoc(inspectionDocRef);

      if (inspectionDocSnapshot.exists()) {
        // Update the inspection details
        await updateDoc(inspectionDocRef, {
          inspectionName: values.inspectionName || "",
          // Add other fields you want to update
        });
        toast.success("Inspection details updated successfully.");
        setIsModalOpen(false);
      } else {
        toast.error("No inspection found with the specified ID..");
      }
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const defaultValues = {
    inspectionName: inspectionDetail?.inspectionName, // Initial value for the Name field
  };

  return (
    <div>
      <Header>
        <div className="inspection_topHeader" theme="dark">
          <h1 style={{ fontWeight: 400 }}>
            {inspectionDetail?.inspectionName}
            <span
              style={{ marginLeft: "5px", cursor: "pointer", fontSize: "18px" }}
              onClick={showModal}
            >
              {" "}
              <i className="fa-solid fa-pen"></i>
            </span>
          </h1>
        </div>
      </Header>

      <TempalteItemList companyName={companyName} isCompanyNameFetched={isCompanyNameFetched}/>

      <Modal
        title="Edit Inspection"
        open={isModalOpen}
        centered
        footer={null}
      >
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          autoComplete="off"
          layout="vertical"
          initialValues={defaultValues} // Set the initial values
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            label="Name"
            name="inspectionName"
            rules={[
              {
                required: true,
                message: "Please input inspection template name!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Button type="primary" htmlType="submit">
            Save
          </Button>
          <Button onClick={handleCancel} style={{marginLeft:'10px'}}>Cancel</Button>
        </Form>
      </Modal>
    </div>
  );
};

export default NewTemplate;
